






































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { mask } from "vue-the-mask";
import { Person } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
import ppdwTextField from "@/components/shared/ppdwTextField.vue";
@Component({ directives: { mask } })
export default class PersonContacts extends Vue {
    @Prop() person: Person;
    Rules = ValidationRules;
    @Ref("phoneInput") phoneInput: ppdwTextField;
    @Ref("emailInput") emailInput: ppdwTextField;

    mounted() {
        this.initPhone();
    }

    initPhone() {
        // Небольшой костылёк чтобы номер форматировался при создании компонента
        if (/(^\d{11}$)/.test(this.person.phone)) {
            this.phoneInput.model = this.person.phone.replace(
                /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2}).*/,
                "+$1-$2-$3-$4-$5"
            );
        }else if(!this.phoneInput.model){
            this.phoneInput.model = "+7"
        }
    }

    get email() {
        return this.person.email;
    }
    set email(v) {
        this.person.email = v.trim();
        this.$nextTick(()=>{
            this.emailInput.model = this.person.email
        })
    }


    get phone() {
        return this.person.phone;
    }
    set phone(v) {
        this.person.phone = v;
        if (v.length == 16) {
            this.person.phone = v.match(/\d+/g).join("");
            this.$nextTick(() => {
                this.phoneInput.model = this.person.phone.replace(
                    /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2}).*/,
                    "+$1-$2-$3-$4-$5"
                );
            });
        }
    }
}
